export const container: React.CSSProperties = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  lineHeight: "80px",
};

export const containerRight: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
};

export const SwitchContainer: React.CSSProperties = {
  display: "flex",
  width: 72,
  lineHeight: "32px",
  backgroundColor: "#373739",
  color: "#fff",
  borderRadius: 100,
  overflow: "hidden",
  marginLeft: 10,
};

export const SwitchItem: (active: boolean) => React.CSSProperties = function (
  active
) {
  const dynamicStyle = active
    ? {
        color: "#242428",
        backgroundColor: "#FFE804",
      }
    : {
        color: "#fff",
        backgroundColor: "#373739",
      };

  return {
    ...dynamicStyle,
    flex: 0.5,
    textAlign: "center",
    cursor: "pointer",
  };
};
